// FIXME: Update this configuration file based on your project information

import type { Locale } from '@/i18n/types';

export const AppConfig = {
  name: 'Sweep King',
  title: 'Sweep King',
  description: 'Legal online casino platform',
  locale: 'en',
  defaultLocale: 'en' as Locale,
  country: 'US',
  email: 'support@sweepking.com',
};
